import styled from 'styled-components';
import Parent from './style';
const Wrapper = styled(Parent.Wrapper)`
    padding-left: 24%;
`;

const Styled = { Wrapper};

export default Styled;
